import React from 'react';
import { Typography } from '../components/Typography';
import styles from './privacy-policy.module.scss';
import axios from 'axios';
import PageWrapper from '../components/PageWrapper';
import SEO from '../components/SEO';

interface PrivacyPolicyProps {
  aboutData: any[];
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ aboutData }) => {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Read EPEN Ltd. Privacy Policy to understand how we collect, use, and protect your personal information. Your privacy matters to us. Learn more!"
        keywords="privacy policy, data protection, epen"
      />
      <PageWrapper
      dateText="Current as of 20 Jan 2025"
      titleText="Privacy Policy"
      introText="Your privacy is important to us at Untitled. We respect your privacy regarding any information we may collect from you across our website."
      title="Privacy Policy"
      headerContainerClass={styles.headerContainer}
      aboutData={aboutData}
    >
      <div className={styles.contentSection}>
        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi eleifend
          faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam enim urna,
          etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At feugiat sapien
          varius id.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Eget quis mi enim, leo lacinia pharetra, semper. Eget in volutpat mollis at volutpat
          lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant
          diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum
          molestie aliquet sodales id est ac volutpat.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            What information do we collect?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In
          aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam
          in vitae malesuada fringilla.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur
          convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna.
          Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue
          convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies
          eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus in tellus, pharetra,
          porttitor.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque
          congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci,
          tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat
          nam nibh orci.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            How do we use your information?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In
          aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam
          in vitae malesuada fringilla.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur
          convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna.
          Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue
          convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies
          eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus in tellus, pharetra,
          porttitor.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque
          congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci,
          tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat
          nam nibh orci.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            Do we use cookies and other tracking technologies?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper
          porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi
          mattis id in ac pellentesque ac.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            How long do we keep your information?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper
          porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi
          mattis id in ac pellentesque ac.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            How do we keep your information safe?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper
          porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi
          mattis id in ac pellentesque ac.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            What are your privacy rights?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam ullamcorper
          porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu. Maecenas est morbi
          mattis id in ac pellentesque ac.
        </Typography>

        <div className={styles.subsection}>
          <Typography
            variant="display-xs"
            color="primary"
            weight="bold"
            className={styles.subheading}
          >
            How can you contact us about this policy?
          </Typography>
        </div>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
        >
          Sagittis et eu at elementum, quis in. Proin praesent volutpat egestas sociis sit lorem
          nunc nunc sit. Eget diam curabitur mi ac. Auctor rutrum lacus malesuada massa ornare et.
          Vulputate consectetur ac ultrices at diam dui eget fringilla tincidunt. Arcu sit dignissim
          massa erat cursus vulputate gravida id. Sed quis auctor vulputate hac elementum gravida
          cursus dis.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
          style={{ marginLeft: '16px' }}
        >
          1. Lectus id duis vitae porttitor enim gravida morbi.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
          style={{ marginLeft: '16px' }}
        >
          2. Eu turpis posuere semper feugiat volutpat elit, ultrices suspendisse. Auctor vel in
          vitae placerat.
        </Typography>

        <Typography
          variant="text-lg"
          color="secondary"
          weight="normal"
          className={styles.paragraph}
          style={{ marginLeft: '16px' }}
        >
          3. Suspendisse maecenas ac donec scelerisque diam sed est duis purus.
        </Typography>
      </div>
    </PageWrapper>
    </>
  );
};

export const getServerSideProps = async () => {
  let aboutData = [];

  try {
    const aboutResponse = await axios.get(
      `${process.env.NEXT_PUBLIC_REACT_APP_BASE_URL1}/about-us`
    );
    aboutData = aboutResponse.data.data || [];
  } catch (err) {
    console.error('Error fetching about-us data for privacy-policy page:', err);
  }

  return {
    props: {
      aboutData: aboutData,
    },
  };
};

export default PrivacyPolicy;
